const DELIVERY_UNTIL_MESSAGE = 'Entrega até ';
const DELIVERY_UNTIL_TODAY_MESSAGE = 'Entrega prevista para ';

const RECEIVED_BY_MESSAGE = 'Recebido por';
const DELIVERED_AT_MESSAGE = 'Entregue';
const DELIVERED_IN_MESSAGE = 'Entregue em';
const YESTERDAY_AT_MESSAGE = 'ontem às';
const TODAY_AT_MESSAGE = 'hoje às';
const TODAY_TEXT = 'hoje';
const TOMORROW_TEXT = 'amanhã';
const AT_TEXT = ' às ';

export {
  DELIVERY_UNTIL_MESSAGE,
  DELIVERY_UNTIL_TODAY_MESSAGE,
  RECEIVED_BY_MESSAGE,
  DELIVERED_AT_MESSAGE,
  DELIVERED_IN_MESSAGE,
  YESTERDAY_AT_MESSAGE,
  TODAY_AT_MESSAGE,
  TODAY_TEXT,
  TOMORROW_TEXT,
  AT_TEXT
};
